<template>
  <div>
    <div class="mb-10 relative">
      <ValidationProvider
        name="confirm"
        rules="required|min:8"
        v-slot="{ errors, invalid }"
      >
        <zt-tooltip
          :position="isMobile ? 'top' : 'left'"
          :clickable="true"
          color="dark-300"
          outlined
          :shadow="true"
        >
          <div slot="body" class="p-3">
            <PasswordPolicies :pass-policies="passwordPolicies" />
          </div>
          <zt-input
            outlined
            name="password"
            type="password"
            v-model="value.password"
            :label="$t('message.loginComponent.languagesVuetify.newPassword')"
            :style="[firstLoginCustomParamsFields.styles.form.inputs.bgColor]"
            data-vs-input="auth-resetpass-fields-input-pass"
          />
        </zt-tooltip>
      </ValidationProvider>
    </div>
    <div class="mb-10 relative">
      <ValidationProvider
        rules="required|password:@confirm"
        v-slot="{ errors, invalid }"
      >
        <zt-input
          outlined
          name="rePassword"
          type="password"
          :label="$t('message.loginComponent.languagesVuetify.repeatPassword')"
          :style="[firstLoginCustomParamsFields.styles.form.inputs.bgColor]"
          v-model="value.rePassword"
          :color="colorOutlineRePass(invalid)"
          data-vs-input="auth-resetpass-fields-input-repass"
        />
        <span class="text-zt-danger absolute left-0" v-show="errors[0]"
          >{{
            $t(
              'message.settingsComponent.list.changePassword.samePassValidation'
            )
          }}
        </span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import PasswordPolicies from '@/components/generics/passwordPolicies'
import { useWindowResize } from '@sichern/ui-elements'

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: ''
})

export default {
  name: 'ztAuthResetPassFields',
  components: {
    PasswordPolicies
  },
  props: {
    passwordPolicies: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Object,
      default: () => ({
        password: '',
        rePassword: ''
      })
    },
    firstLoginCustomParamsFields: {
      type: Object,
      default: () => {}
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      isInvalid: null,
      windowSize: useWindowResize(this)
    }
  },
  created() {},
  computed: {
    isEqualsPassword() {
      return this.value.password === this.value.rePassword
    },
    colorOutlineRePass() {
      return (errors) =>
        errors
          ? 'danger'
          : this.firstLoginCustomParamsFields.styles.form.inputs.outlineColor
    },
    isMobile() {
      return this.windowSize.width < 1024
    },
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
.tooltip-body {
  color: #575757;
  .tooltip-title {
    color: #03a9f4;
  }
}
</style>
